module.exports = __webpack_public_path__ + "img/1925.71da1314.svg";